import { render, staticRenderFns } from "./AlterarSenhaUsuarioModal.vue?vue&type=template&id=09801c2f&scoped=true"
import script from "./AlterarSenhaUsuarioModal.vue?vue&type=script&lang=js"
export * from "./AlterarSenhaUsuarioModal.vue?vue&type=script&lang=js"
import style0 from "./AlterarSenhaUsuarioModal.vue?vue&type=style&index=0&id=09801c2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09801c2f",
  null
  
)

export default component.exports